export const COMPONENTS_ERROR_ANALYTICS = 'directories.components.error';
